import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import { BladeCal } from '@/constants/blade';

export default function Step4({ callBack, calObj }: any) {
    const { useState, useLang, gtm } = useGlobal();
    const { t } = useLang('bladecalculator');
    const [checked, setChecked] = useState(calObj?.check4 || 0);
    const SHADOW_PERCENT_ARR: any = [
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step4_1.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step4_1.png')}
                    alt={t('detail.calculator_step4_text1')}
                    aria-label={t('detail.calculator_step4_text1')}
                />
            ),
            text: t('detail.calculator_step4_text1'),
        },
        {
            img: (
                <NextImage
                    webpSrc={require('@publicLocal/blade/calculator/pc/cal_step4_2.webp')}
                    src={require('@publicLocal/blade/calculator/pc/cal_step4_2.png')}
                    alt={t('detail.calculator_step4_text2')}
                    aria-label={t('detail.calculator_step4_text2')}
                />
            ),
            text: t('detail.calculator_step4_text2'),
        },
    ];
    const handleCheck = (n: number) => {
        setChecked(n + 1);
        callBack({
            ...calObj,
            currentStep: 4,
            check4: n + 1,
        });
    };
    const handleNext = () => {
        callBack({ ...calObj, currentPage: BladeCal.Step5 });
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process4',
            step: 'Lawn type',
            product_name: 'EcoFlow BLADE',
            button_name: 'Next',
            option_name: SHADOW_PERCENT_ARR[checked ? checked - 1 : checked]?.text,
        });
    };
    const handleBack = () => {
        callBack({ ...calObj, currentPage: BladeCal.Step3, currentStep: 3, check4: undefined });
    };
    return (
        <div className={`step4 ${css.step4}`}>
            <p className="step4-title">{t('detail.calculator_step4_title')}</p>
            <ul className="step4-box">
                {SHADOW_PERCENT_ARR?.map((shadow: any, k: number) => (
                    <li className="step4-item" key={shadow?.text} onClick={() => handleCheck(k)}>
                        <div className="img-box">
                            {shadow?.img}
                            {checked === k + 1 && (
                                <>
                                    <div className="mask"></div>
                                    <EFChecked className="checked" />
                                </>
                            )}
                        </div>
                        <p className="img-text">{shadow?.text}</p>
                    </li>
                ))}
            </ul>
            <div className="step4-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('detail.calculator_btn_back')}
                </button>
                <button className="btn-next" disabled={!checked} onClick={handleNext}>
                    {t('detail.calculator_btn_next')}
                </button>
            </div>
        </div>
    );
}
